export enum SelectionPanelGroupTheme {
    Blue = 'blue',
    Red = 'red',
    Gray = 'gray',
}
